module.exports = __webpack_public_path__ + "img/new_onerequest_960.d51203ab.png";